import { notification } from 'antd'
import { useMutation } from 'react-query'
import { useTranslation } from 'react-i18next'

import { AxiosErrorType } from '@types'

import { postCarrierAvailability } from '../api'

const useDeclareCarrierAvailability = (onCreateSuccess: () => void) => {
  const { t } = useTranslation()
  const tPreffix = 'carrier_availability'

  const { mutate, isLoading } = useMutation(postCarrierAvailability, {
    onSuccess: () => {
      notification.success({
        message: t(`${tPreffix}.declaration_done`),
      })
      onCreateSuccess()
    },
    onError: (err: unknown) => {
      const error = err as AxiosErrorType

      const { message } = error.data.error as {
        type: string
        status: number
        message: string
      }

      notification.error({
        message: message ? t(`globals.${message}`) : 'Se produjo un error desconocido',
      })
    },
  })

  return {
    declareCarrierAvailability: mutate,
    declareCarrierAvailabilityIsLoading: isLoading,
  }
}

export { useDeclareCarrierAvailability }
